/* eslint-disable */
import api from '../_api'

export const customerService = {
  createCustomer(payload) {
    return api.post('/customer/', payload)
  },
  getCustomerForTeam(teamid) {
    return api.get(`/customer/?assigned_team=${teamid}`)
  },
  getCustomerUnassigned(q) {
    let url = '/customer/?unassigend=true'
    if (q != null && q.length > 0) {
      url = `/customer/?unassigend=true&search=${q}`
    }
    return api.get(url)
  },
  getCustomers(args) {
    return api.get('/customer/', {
      params: args,
    });
  },
  patchCustomer(payload) {
    return api.patch(`/customer/${payload.pk}/`, payload)
  },
  getCustomer(id, kwargs) { //scope = null, includeSpend = false) {
    return api.get(`/customer/${id}/`, {params: kwargs})
  },
  getCustomerRequiredFields() {
    return api.get('/customer/required_customer_fields/');
  },
  deleteCustomer({id, scope}) {
    return api.delete(`/customer/${id}/`, { params: { scope } })
  },
  getGroup(id, scope = null) {
    console.log('SCOPE: ', { scope })
    return api.get(`/customer-group/${id}/`, { params: scope })
  },
  patchGroup(payload) {
    return api.patch(`/customer-group/${payload.pk}/`, payload)
  },
  addGroupMembers(payload) {
    return api.post(`/customer-group/${payload.id}/create_members/`, payload)
  },
  getGroupMembers(id, args) {
      return api.get(`/customer-group/${id}/members/`, {
      params: args,
    });
  },
  getGroups(args) {
    let str;
    if (args) {
      str = args.search;
    }
    if (str) {
      return api.get(`/customer-group/?search=${str}`);
    }
    return api.get('/customer-group/', {
      params: args,
    });
  },
  createGroup(payload) {
    return api.post('/customer-group/create_group/', payload)
  },
  deleteGroup(id) {
    return api.delete(`/customer-group/${id}/`)
  },
  deleteGroupMember(payload) {
    const { id } = payload
    return api.post(`/customer-group/${id}/delete_member/`, payload)
  },
  getStats() {
    return api.get('customer/stats/');
  },
  fetchNotes(id) {
    return api.get('/notes/', {
      params: { customer: id },
    })
  },
  addNote(payload) {
    return api.post('/notes/', payload);
  },
  deleteNote(customerPk, id) {
    return api.delete(`/notes/${id}/?customer=${customerPk}`);
  },
  changeSubscription(payload) {
    return api.patch(`/customer/${payload.pk}/subscription_change/`, payload);
  },
  getLikes(customerId) {
    return api.get(`/customer/${customerId}/retrieve_likes/`);
  },
}
